<div class="p-3 bg-white">
    <div class="modal-header">
        <h5 class="modal-title w-100 pe-2" id="myModalLabel">{{userPersistenceService.generalTranslation.LandingPopUpTitle}}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
    </div>

    <div class="modal-body">
        <p>
            {{userPersistenceService.generalTranslation.ChangeLandingPage}}
        </p>
        <ifc-select name="landingPage" [form]="form" [schema]="schema" [options]="landingPageDropDown" labelprop="text"
                    valueprop="key"></ifc-select>
        <p><b>{{userPersistenceService.generalTranslation.LandingPopUpNote}}</b></p>
    </div>
    <div class="modal-footer mt-2">
        <div class="col-md-12 text-end pt-3 pe-0 pb-0 ps-0">
            <ifc-checkbox name="hideLandingPagePopUp" [form]="form" [schema]="schema"
                          [label]="'Do not show this pop-up again'"></ifc-checkbox>
            <button type="button" mat-raised-button color="primary" class="relative btn text-uppercase body2 mt-3 mb-0 pt-2 pb-2 no-shadow rounded me-0 ms-2 btn-min-width me-0"
                    (click)="onSaveClick()">
                {{userPersistenceService.generalTranslation.Save}}
            </button>
        </div>
    </div>
</div>
